import angular from 'angular'
import { sharedModule } from './shared'
import { serverMetadata } from './ng/components/server-details/index'
import { applicationMetadata } from './ng/components/application-details'
import {
  applicationTooltip,
  serverApplicationTooltip,
  protectApplicationTooltip
} from './ng/components/application-tooltip'
import { reactAuditLogTable } from './ng/components/audit-log'
import { reactRemediationPolicyViolationWarning } from './ng/components/remediation-policy/warning'
import { reactDropdown } from './ng/components/dropdown/index'
import { reactLicensePolicyForm } from './ng/components/license-policy-form/index'
import { reactSlidingTutorial } from './ng/components/sliding-tutorial/index'
import { reactOnboardingHeader } from './ng/components/onboarding-header/index'
import { reactRouteCoverageChart } from './ng/components/route-coverage-chart/index'
import { reactAppOverviewFrameworks } from './ng/components/application-overview/app-overview-frameworks'
import { reactRoutesShorthandMetric } from './ng/components/routes-shorthand-metric/index'
import { reactApiOnlyLabel } from './ng/components/api-only-label/index'
import { yourKeys } from './ng/components/your-keys/index'
import { apiKeys } from './ng/components/api-keys/index'
import { organizationApplicationsSettingsForm } from './ng/components/organization-applications-settings-form'
import { updateStatuses } from './ng/components/updates-statuses-action'
import { moduleName as ngInjector } from './ng-injector'
import { reactAppUnlicensedLink } from './ng/components/app-unlicensed-link'
import { reactPendingStatusIndicator } from './ng/components/pending-status-indicator'
import { vulnerabilitySeverityBadge } from './ng/components/vulnerability-severity-badge'
import { vulnerabilityDeleteAction } from './ng/components/vulnerability-delete-action'
import { vulnerabilityDetails } from './ng/components/vulnerability-details'
import { reactAddAgentWizard } from './ng/components/add-agent'
import { reactAddNewSensorButton } from './ng/components/add-new-sensor-button'
import { reactArchiveDialog } from './ng/components/actions/archive-dialog'
import { reactAttackEventOverview } from './ng/components/attack-event-overview'
import { reactAttackEventDetail } from './ng/components/attack-event-details'
import { reactVr } from './ng/components/value-reporting'
import { libraryRestrictionIcon } from './ng/components/library-restriction-icon'
import { reactOrganizationRoleCombobox } from './ng/components/organization-role-combobox'
import { reactAgentStatusTooltip } from './ng/components/agent-status-tooltip'
import { reactAppInstrumentationTooltip } from './ng/components/app-instrumentation-tooltip'
import { reactServerInstrumentationTooltip } from './ng/components/server-instrumentation-tooltip'
import {
  reactSourceNamesManager,
  reactSourceNameAdd,
  reactSourceNameEdit
} from './ng/components/source-names'
import { attackers } from './ng/components/monitor'
import { notificationSubscriptionRow } from './ng/components/notification-subscription-row'
import { reactAttackEventValueTooltip } from './ng/components/attack-event-value-tooltip'
import { reactApplicationFlowMap } from './ng/components/application-flow-map'
import { reactAttackEventDrilldown } from './ng/components/attack-event-drilldown'
import { downloadAttackValueLink } from './ng/components/download-attack-value-link'
import { reactSensitiveDataGrid } from './ng/components/sensitive-data/sensitive-data-grid'
import { reactSensitiveDataTypeForm } from './ng/components/sensitive-data/edit-sensitive-data-type-form'
import { applicationReportsButton } from './ng/components/application-reports-button'
import { reactIconWrapper } from './ng/components/icon'
import { reactDependencyTree } from './ng/components/dependency-tree'
import { reactVulnerabilityPoliciesManager } from './ng/components/vulnerability-management/vulnerability-policies-manager'
import { reactVulnerabilityBehaviorManager } from './ng/components/vulnerability-management/vulnerability-behavior-manager'
import {
  reactVulnerabilityPolicyEdit,
  reactVulnerabilityPolicyAdd
} from './ng/components/vulnerability-management'
import { telemetryOrgSettingsToggle } from './ng/components/telemetry/telemetry-org-settings-toggle'
import { serverCleanupOrgSettingsToggle } from './ng/components/server-cleanup/server-cleanup-org-settings-toggle'
import { reactEmailDomainsSecuritySection } from './ng/components/security/email-domains-section'
import {
  organizationPolicyViolationsNotificationSettings,
  userPolicyViolationsNotificationSettings
} from './ng/components/policy-violations-notification-settings'
import { generalOrganizationSettingsWrapper } from './ng/components/general-organization-settings'
import { reactSendToEmailDialog } from './ng/components/send-to-email-dialog'
import { reactLocaleSelector } from './ng/components/locale-selector'
import { reactEmptyActivityPanel } from './ng/components/empty-activity-panel'
import { librariesMultiSelectCombobox } from './ng/components/libraries-multi-select-combobox'
import { reactToggleToNewDashboard } from './ng/components/dashboard-toggle'
import { reactIntegrationsDropdown } from './ng/components/integrations-dropdown'
import { reactJenkinsRulesThresholds } from './ng/components/jenkins-rules-threshold'
import { reactMultiselectCombobox } from './ng/components/multi-select-combobox'
import { reactJenkinsDatePickerDropdown } from './ng/components/jenkins-date-picker-dropdown'
import { detailTags } from './ng/components/detail-tags'
import { scansApplication } from './ng/components/scans-application'
import { accessControlSettings } from './ng/components/access-control-settings'
import { reactServerOverviewToggle } from './ng/components/server-overview-toggle'
import { reactDefaultPolicyConfigLink } from './ng/components/default-policy-config-link'
import { reactCookieBanner } from './ng/components/cookie-banner'
import { reactProtectRulesDefaultsGrid } from './ng/components/protect-rules'
import { reactCveShieldsDefaultsGrid } from './ng/components/cve-shields'
import { reactNotificationsMenu } from './ng/components/notifications'
import {
  reactJiraIntegrationPage,
  reactIntegrationsListView
} from './ng/components/integrations/'
import { reactAddExclusionButton } from './ng/components/add-exclusion-button/'
import { reactAddExclusionAction } from './ng/components/add-exclusion-action/'
import { reactAppActivityEmptyState } from './ng/components/app-activity'
import { reactAttackEmptyState } from './ng/components/empty-attack-grid'
import { reactPrimaryApplicationClickableIcon } from './ng/components/clickable-primary-application-icon'
import { reactEditExclusionDialog } from './ng/components/edit-exclusion-action'
import { reactEditExclusionPanel } from './ng/components/edit-exclusion-panel'
import { reactPrimaryApplicationIcon } from './ng/components/primary-application-indicator'
import { retainLibraryDataOrgSettingsToggle } from './ng/components/retain-library-data/retain-library-data-server-settings-toggle'
import { reactLegacyGridIpListDescription } from './ng/components/legacy-grid-description'
import { reactModifySingleServerSettingsDialog } from './ng/components/server-settings'
import { reactProtectServerDefaultsForm } from './ng/components/protect-server-defaults-form'
import { reactMfeLicensesPanel } from './ng/components/org-settings-license-panel'
import { reactMfeMfaBanner } from './ng/components/mfa-banner'
import { reactMfeMfaPanel } from './ng/components/mfa-panel'
import { reactMfeImpersonationPanel } from './ng/components/impersonation-panel'
import { reactMfeRepositoriesPanel } from './ng/components/platform-repositories'
import { reactToast } from './ng/components/toast'
import { reactServerThermometer } from './ng/components/server-thermometer'
import { reactServerSummaryLegend } from './ng/components/server-summary-legend'
import { reactNoAssessServersModal } from './ng/components/no-assess-servers-modal'
import { reactNewRuleBadge } from './ng/components/new-rule-badge'
import { reactServerOverviewVulnerability } from './ng/components/server-overview-vulnerability'
import { resetApplication } from './ng/components/reset-application'
import { reactLibrariesMfe } from './ng/components/libraries-mfe/libraries-mfe'
import { reactSelectSensorWizard } from './ng/components/select-sensor-wizard/select-sensor-wizard'
import {
  reactMfeProtectRules,
  reactMfeProtectRulesDefaults,
  reactMfeProtectRuleDrilldown
} from './ng/components/mfe-protect-rules'
import { freeTrialWrapper } from './ng/components/free-trial'
import { reactAiHowToFix } from './ng/components/ai-ml'
import {
  reactAssessPanelHeader,
  reactPanelHeader,
  reactProtectPanelHeader,
  reactShieldsPanelHeader
} from './ng/components/policy-management'
import { reactUserPermissions } from './ng/components/users-permissions/'
import { reactTextOverflow } from './ng/components/text-overflow/'
import { organizationApiKeys } from './ng/components/organization-api-key'
import { reactScanProjectsPage } from './components/scan-projects'
import { serverReportsButton } from './ng/components/server-reports-button'
import {
  reactTtrRangeTypeDropdown,
  reactTtrDateRangeDropdown
} from './ng/components/ttr-date-range-dropdown'
import { reactSidecar } from './ng/components/sidecar'
import { reactVulnerabilityTtrManager } from './ng/components/vulnerability-management/vulnerability-ttr-manager'
import { failedScanNotificationSettings } from './ng/components/failed-scan-notification-settings'

export const orgPortalEntry = angular.module('contrast.react.org', [
  sharedModule,
  reactRemediationPolicyViolationWarning,
  reactIconWrapper,
  reactDependencyTree,
  serverMetadata,
  reactServerOverviewToggle,
  applicationMetadata,
  scansApplication,
  accessControlSettings,
  applicationTooltip,
  serverApplicationTooltip,
  protectApplicationTooltip,
  reactDropdown,
  reactLicensePolicyForm,
  reactSlidingTutorial,
  reactOnboardingHeader,
  reactAppOverviewFrameworks,
  reactRouteCoverageChart,
  reactRoutesShorthandMetric,
  reactApiOnlyLabel,
  freeTrialWrapper,
  yourKeys,
  apiKeys,
  organizationApiKeys,
  organizationApplicationsSettingsForm,
  updateStatuses,
  reactAppUnlicensedLink,
  reactPendingStatusIndicator,
  vulnerabilitySeverityBadge,
  vulnerabilityDeleteAction,
  vulnerabilityDetails,
  reactArchiveDialog,
  reactAddAgentWizard,
  reactAddNewSensorButton,
  reactSelectSensorWizard,
  ngInjector,
  reactAttackEventOverview,
  reactAttackEventDetail,
  libraryRestrictionIcon,
  reactOrganizationRoleCombobox,
  reactAgentStatusTooltip,
  reactAppInstrumentationTooltip,
  reactServerInstrumentationTooltip,
  reactSourceNamesManager,
  reactSourceNameAdd,
  reactSourceNameEdit,
  attackers,
  notificationSubscriptionRow,
  reactAttackEventValueTooltip,
  reactApplicationFlowMap,
  reactAttackEventDrilldown,
  downloadAttackValueLink,
  reactSensitiveDataGrid,
  reactSensitiveDataTypeForm,
  applicationReportsButton,
  serverReportsButton,
  reactVulnerabilityPoliciesManager,
  reactVulnerabilityBehaviorManager,
  reactVulnerabilityTtrManager,
  reactVulnerabilityPolicyEdit,
  reactVulnerabilityPolicyAdd,
  telemetryOrgSettingsToggle,
  serverCleanupOrgSettingsToggle,
  retainLibraryDataOrgSettingsToggle,
  reactEmailDomainsSecuritySection,
  organizationPolicyViolationsNotificationSettings,
  userPolicyViolationsNotificationSettings,
  reactSendToEmailDialog,
  generalOrganizationSettingsWrapper,
  reactLocaleSelector,
  reactEmptyActivityPanel,
  reactVr,
  librariesMultiSelectCombobox,
  reactToggleToNewDashboard,
  reactJenkinsRulesThresholds,
  reactJenkinsDatePickerDropdown,
  reactIntegrationsDropdown,
  reactMultiselectCombobox,
  detailTags,
  reactDefaultPolicyConfigLink,
  reactCookieBanner,
  reactProtectRulesDefaultsGrid,
  reactCveShieldsDefaultsGrid,
  reactNotificationsMenu,
  reactCveShieldsDefaultsGrid,
  reactIntegrationsListView,
  reactJiraIntegrationPage,
  reactAddExclusionButton,
  reactAddExclusionAction,
  reactAppActivityEmptyState,
  reactAttackEmptyState,
  reactPrimaryApplicationClickableIcon,
  reactEditExclusionDialog,
  reactEditExclusionPanel,
  reactPrimaryApplicationIcon,
  reactLegacyGridIpListDescription,
  reactModifySingleServerSettingsDialog,
  reactProtectServerDefaultsForm,
  reactMfeLicensesPanel,
  reactMfeMfaBanner,
  reactMfeMfaPanel,
  reactMfeImpersonationPanel,
  reactMfeRepositoriesPanel,
  reactToast,
  reactServerThermometer,
  reactServerSummaryLegend,
  reactNoAssessServersModal,
  reactNewRuleBadge,
  reactServerOverviewVulnerability,
  resetApplication,
  reactLibrariesMfe,
  reactMfeProtectRules,
  reactMfeProtectRulesDefaults,
  reactMfeProtectRuleDrilldown,
  reactAiHowToFix,
  reactAssessPanelHeader,
  reactPanelHeader,
  reactProtectPanelHeader,
  reactShieldsPanelHeader,
  reactAuditLogTable,
  reactUserPermissions,
  reactTextOverflow,
  reactScanProjectsPage,
  reactTtrRangeTypeDropdown,
  reactTtrDateRangeDropdown,
  reactSidecar,
  failedScanNotificationSettings
]).name
